/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Step_Indicator_CurrentInputs */

const tr_geliver_step_indicator_current = /** @type {(inputs: Geliver_Step_Indicator_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ŞU AN`)
};

const en_geliver_step_indicator_current = /** @type {(inputs: Geliver_Step_Indicator_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CURRENT`)
};

const de_geliver_step_indicator_current = /** @type {(inputs: Geliver_Step_Indicator_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTUELL`)
};

const ru_geliver_step_indicator_current = /** @type {(inputs: Geliver_Step_Indicator_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТЕКУЩИЙ`)
};

/**
* | output |
* | --- |
* | "CURRENT" |
*
* @param {Geliver_Step_Indicator_CurrentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_step_indicator_current = /** @type {((inputs?: Geliver_Step_Indicator_CurrentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Step_Indicator_CurrentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_step_indicator_current(inputs)
	if (locale === "de") return de_geliver_step_indicator_current(inputs)
	if (locale === "ru") return ru_geliver_step_indicator_current(inputs)
	return tr_geliver_step_indicator_current(inputs)
});